export default {
  dialog: {
    title: "下载调证",
  },
  common: {
    loading: "拼命加载中",
    download: "下载",
    empty: "暂无数据",
  },
  columns: {
    fileName: "文件名称",
    uploader: "上传人",
    uploadTime: "上传时间",
  },
};
